import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-loading-and-no-data-template',
    templateUrl: './loading-and-no-data-template.component.html',
    standalone: false
})
export class LoadingAndNoDataTemplateComponent {

  @Input() isLoading: boolean;
  @Input() height = 100;

}
